import { orderByIdQuery } from 'utils/queries'

export default async function loadOrderById({ props, graphql }) {
  const { id, onlyAttest = false } = props

  const result = await graphql.query(orderByIdQuery({ orderId: id }))
  return {
    unit: result.orderById.unit,
    order: result.orderById.orderItems.reduce((acc, item) => {
      const { source: { waitAttestAt } } = item
      if (onlyAttest) {
        if (waitAttestAt) {
          acc[item.id] = {
            ...item
          }
        }
      } else {
        acc[item.id] = {
          ...item
        }
      }

      return acc
    }, {})
  }
}



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/actions/loadOrderById.js